import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';
const badgeVariants = cva('inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset', {
    variants: {
        tone: {
            neutral: 'bg-muted text-muted-foreground ring-border',
            info: 'bg-blue-500/10 text-blue-700 ring-blue-500/20 dark:text-blue-300',
            success: 'bg-emerald-500/10 text-emerald-700 ring-emerald-500/20 dark:text-emerald-300',
            warning: 'bg-amber-500/10 text-amber-700 ring-amber-500/20 dark:text-amber-300',
            danger: 'bg-red-500/10 text-red-700 ring-red-500/20 dark:text-red-300',
            purple: 'bg-purple-500/10 text-purple-700 ring-purple-500/20 dark:text-purple-300',
        },
    },
    defaultVariants: { tone: 'neutral' },
});
export function Badge({ className, tone, dot, children, ...props }) {
    return (_jsxs("span", { ...props, className: cn(badgeVariants({ tone }), className), children: [dot && _jsx("span", { className: "h-1.5 w-1.5 rounded-full bg-current" }), children] }));
}
const STATE_TONE = {
    // Sales / billing
    draft: 'neutral', open: 'info', sent: 'info', viewed: 'info', paid: 'success',
    partially_paid: 'warning', overdue: 'danger', void: 'neutral', uncollectible: 'danger',
    // Subscriptions
    trialing: 'info', active: 'success', past_due: 'warning',
    suspended: 'danger', canceled: 'neutral', expired: 'neutral',
    // POS / sessions
    closed: 'neutral',
    // Work orders / transfers
    in_progress: 'warning', completed: 'success', in_transit: 'info', received: 'success',
    // Approval
    pending: 'warning', approved: 'success', rejected: 'danger',
    // Stock moves
    receipt: 'success', issue: 'warning', adjustment: 'warning', scrap: 'danger',
    // Tasks
    todo: 'neutral', review: 'info', done: 'success', blocked: 'danger',
    // Virus scan
    clean: 'success', infected: 'danger', skipped: 'neutral',
    // Time entries
    submitted: 'info', invoiced: 'purple',
};
export function StateBadge({ state, className }) {
    const tone = STATE_TONE[state] ?? 'neutral';
    const label = state.replace(/_/g, ' ');
    return (_jsx(Badge, { tone: tone, dot: true, className: cn('uppercase tracking-wide', className), children: label }));
}
